/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const searchCollectionV3ItemSchema = z.object({
  id: z.number(),
  title: z.string(),
  slug: z.string(),
  parentTitle: z.string().nullable(),
  posterUrl: z.string().nullable(),
  thumbnailUrl: z.string().nullable(),
  titleInPoster: z.number().default(0),
  publishedChallengesCount: z.number().default(0),
});

export type ISearchCollectionV3Item = z.infer<typeof searchCollectionV3ItemSchema>;

export const searchCollectionsV3ResponseSchema = createApiResponseSchema(
  z.array(searchCollectionV3ItemSchema),
) as z.ZodSchema<IAPI<ISearchCollectionV3Item[]>>;

export type ISearchCollectionsV3Response = IAPI<ISearchCollectionV3Item[]>;
